import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
    isImap: boolean;
    hostName: string;
    port: number;
    ssl: boolean;
    onSettingsChange: (name: string, value: string | boolean) => void;
}

export default function UserEmailAdvanced({
    isImap,
    hostName,
    port,
    ssl,
    onSettingsChange,
}: Props) {
    const { classes } = useStyles();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let fieldValue: string | boolean | number;

        switch (event.target.type) {
            case 'checkbox':
                fieldValue = event.target.checked;
                break;
            default:
                fieldValue = event.target.value;
        }

        onSettingsChange(event.target.name, fieldValue);
    };

    return (
        <>
            <Grid item>
                <Divider />
            </Grid>
            <Grid item justifyContent="center">
                <Typography variant="h6">
                    {`${isImap ? 'Incoming (IMAP)' : 'Outoging (SMTP)'} mail server settings`}
                </Typography>
            </Grid>
            <Grid item container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item xs={12} sm={4}>
                    <Typography component="p" variant="body2">
                        Host name:
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <TextField
                        name={isImap ? 'imapHost' : 'smtpHost'}
                        label="Host name"
                        value={hostName}
                        size="small"
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>
            </Grid>
            <Grid item container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item xs={12} sm={4}>
                    <Typography component="p" variant="body2">
                        Port:
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <TextField
                        name={isImap ? 'imapPort' : 'smtpPort'}
                        label="Port"
                        value={port}
                        type="number"
                        size="small"
                        fullWidth
                        onChange={handleChange}
                    />
                </Grid>
            </Grid>
            <Grid item container direction="row" justifyContent="space-between" alignItems="center">
                <Grid item xs={12} sm={4}>
                    <Typography component="p" variant="body2">
                        Use SSL/TLS:
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Tooltip title={ssl ? 'Disable' : 'Enable'}>
                        <Switch
                            name={isImap ? 'imapUseSsl' : 'smtpUseSsl'}
                            checked={ssl}
                            onChange={handleChange}
                        />
                    </Tooltip>
                </Grid>
            </Grid>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
